export default "__VITE_ASSET__5f0f4ab9__"